import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { connect, useDispatch } from "react-redux";

//ANT DESIGN IMPORTS
import {
  Input,
  Row,
  Typography,
  Card,
  Select,
  Form,
  DatePicker,
  Col,
  Divider,
  Button,
  Spin,
  Table,
} from "antd";

//ANT DESIGN ICONS IMPORTS
import { ReloadOutlined } from "@ant-design/icons";

//PROJECT IMPORTS
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";
import MainLayout from "../../../components/layouts/enhancement/MainLayout";
import TopContent from "../../../components/layouts/enhancement/TopContent";
import CustomButton from "../../../components/custom/CustomButton";
import dayjs from "dayjs";
import TextArea from "antd/es/input/TextArea";
import { apiConfig, labelConfig, staticConfig } from "../reports.config";
import DownloadTableButtons from "../../../components/layouts/enhancement/DownloadTableButtons";
import ParameterSelector from "../components/ParameterSelector";

const { Text } = Typography;

const RunDepositReports = (props) => {
  const { userData } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const [useForm] = Form.useForm();
  const { state } = useLocation();
  const [tableCount, setTableCount] = useState("10");
  const [customerReportsList, setCustomerReportsList] = useState([]);
  const [columnHeaders, setColumnHeaders] = useState([]);
  const [officesOptions, setOfficesOptions] = useState([]);
  const [officeValue, setOfficeValue] = useState(0);
  const [reportDetail, setReportDetail] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isRun, setIsRun] = useState(false);
  const [fields, setFields] = useState([]);

  useEffect(() => {
    // console.log(state)
    getTemplate();
    getOffices();
    getDetailById();
  }, []);

  console.log(reportDetail, state);
  const getDetailById = (params) => {
    setIsLoading(true);

    const url = `${apiConfig.Reports}/${state?.id}`;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        setIsLoading(false);
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objDetail = res;
        console.log(res);
        setReportDetail(objDetail);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  function getTemplate() {
    const params = {
      R_reportListing: `'${state.name}'`,
      parameterType: true,
    };

    const url = `${apiConfig.RunReports}/FullParameterList`;

    let body = {
      session,
      params,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        const objList = res;
        let tempArray = [];
        console.log(res);
        setFields(res);

        objList.forEach((element) => {
          tempArray.push({
            value: element?.id,
            label: element?.value,
          });

          // setRescheduleTypeData(tempArray)
        });
      }
    });
    setIsLoading(false);
  }

  function getOffices() {
    const params = {
      parameterType: true,
    };

    const url = `${apiConfig.RunReports}/OfficeIdSelectOne`;

    let body = {
      session,
      params,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        const objList = res.data;
        const tempOfficesOptions = [];

        objList?.forEach((element) => {
          tempOfficesOptions.push({
            key: element.row[0],
            value: element.row[0],
            label: element.row[1],
          });
        });

        setOfficesOptions(tempOfficesOptions);
      }
    });
    setIsLoading(false);
  }

  function selectTableCount(value) {
    setTableCount(value);
  }

  const handleOfficeChange = (valueParam) => {
    setOfficeValue(valueParam);
  };

  const columns = columnHeaders.map((item, i) => {
    return {
      title: item.columnName,
      dataIndex: item.columnName,
      key: item.columnName,
      onHeaderCell: () => ({
        style: {
          whiteSpace: "nowrap", // Prevent wrapping
        },
      }),
    };
  });
  function isRunFunction() {
    setIsRun(false);
  }

  // const onRunAction = () => {
  //   const params = {
  //     R_officeId: officeValue,
  //   };
  //   const url = `${apiConfig.RunReports}/${state.name}`;

  //   const body = {
  //     session,
  //     params,
  //   };

  //   setIsLoading(true);

  //   BOM.FetchReqAction(body, url, (err, res) => {
  //     if (err) {
  //       BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
  //       setIsLoading(false);
  //     } else {
  //       const objList = res;
  //       setColumnHeaders(objList.columnHeaders);
  //       let tempCustomerReportsList = [];

  //       objList?.data?.forEach((element, index) => {
  //         tempCustomerReportsList.push({
  //           key: index,
  //           id: index,
  //           office: element.row[0],
  //           clientAccountNo: element.row[1],
  //           name: element.row[2],
  //           status: element.row[3],
  //           activationDate: element.row[4],
  //           externalId: element.row[5] ? element.row[5] : "-",
  //         });
  //       });

  //       setCustomerReportsList(tempCustomerReportsList);
  //       setIsRun(true);
  //       //STOP LOAD
  //       setIsLoading(false);
  //       useForm.resetFields();
  //     }
  //   });
  // };

  console.log(fields);

  return (
    <MainLayout
      isEnableRightSidebar={true}
      pageItems={staticConfig.runDepositReportsBreadcrumbItems}
    >
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent pageTitle={state.name} createPageTitle={labelConfig.runReport} />

      <Spin spinning={isLoading} size="large">
        <Card
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
            marginTop: 12,
          }}
          title={
            isRun && (
              <Button
                type="primary"
                shape="round"
                size="small"
                onClick={isRunFunction}
                icon={<ReloadOutlined />}
                loading={isLoading}
                style={{
                  background: "#BA24D5",
                  borderColor: "#BA24D5",
                  fontSize: 16,
                }}
              >
                Select Parameters
              </Button>
            )
          }
        >
          <ParameterSelector
            customerReportsList={customerReportsList}
            columnHeaders={columnHeaders}
            isRun={isRun}
            session={session}
            fields={fields}
            setCustomerReportsList={setCustomerReportsList}
            setColumnHeaders={setColumnHeaders}
            show={!isRun}
            setIsRun={setIsRun}
          />

          {/* <Form
            form={useForm}
            layout="vertical"
            // onFinish={onRunAction}
          >
            {!isRun && (
              <Row>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item label={labelConfig.office} name="officeId">
                    <Select
                      placeholder={BOM.handlePlaceholderMsg(labelConfig.office, "select")}
                      style={{ height: "44px" }}
                      options={officesOptions}
                      onChange={handleOfficeChange}
                    />
                  </Form.Item>
                </Col>

                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item label={labelConfig.decimalPlaces} name="decimalPlace">
                    <Select
                      placeholder={BOM.handlePlaceholderMsg(labelConfig.decimalPlaces, "select")}
                      style={{ height: "44px" }}
                      options={staticConfig.decimalPlacesData}
                    />
                  </Form.Item>
                </Col>
              </Row>
            )} */}

          {/* <Divider /> */}

          {isRun && (
            <>
              <Row style={{ marginBottom: 20 }}>
                <div style={{ marginBottom: "auto" }}>
                  <Text style={{ marginRight: 8 }}>Show</Text>
                  <Select
                    defaultValue={tableCount}
                    options={[
                      { value: "5", label: "5" },
                      { value: "10", label: "10" },
                      { value: "25", label: "25" },
                      { value: "50", label: "50" },
                    ]}
                    onSelect={selectTableCount}
                  />
                  <Text style={{ marginLeft: 8 }}>Entries</Text>
                </div>
                {/* <div style={{ margin: "0px 50px" }}>
                           <Button
                               type="primary"
                               style={{
                                   background: "#FFFFFF",
                                   borderColor: "#BA24D5",
                                   height: 22,
                                   fontSize: 16,
                                   marginLeft: "auto"
                               }}
                               onClick={setIsRun(false)}
                           >
                               Select Parameters
                           </Button>
                           </div> */}
                <DownloadTableButtons
                  downloadData={customerReportsList}
                  columns={columns}
                  // fileName={"Customer Reports List"}
                  fileName={state.name}
                />
              </Row>
              <Table
                columns={columns}
                dataSource={customerReportsList}
                bordered
                scroll={{ x: 800 }}
                pagination={{
                  position: "bottomCentre",
                  pageSize: tableCount,
                  showSizeChanger: false,
                }}
              />
            </>
          )}

          {/* {!isRun && (
            <Row>
              <Divider />
              <Button
                type="primary"
                style={{
                  background: "#BA24D5",
                  borderColor: "#BA24D5",
                  height: 44,
                  fontSize: 16,
                  marginLeft: "auto",
                }}
                onClick={onRunAction}
              >
                Run Report
              </Button>
            </Row>
          )} */}
          {/* </Form> */}
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

export default connect(mapStateToProps, null)(RunDepositReports);
